/** An insurer's ISO date ("2027-07-27") the way Wing shows dates ("27/07/2027"). */
export const displayDate = (iso: string | null | undefined): string => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso ?? ""));
  return match ? `${match[3]}/${match[2]}/${match[1]}` : iso || "—";
};
